const Dialogs = {
    ALERT_TYPES: {
        SUCCESS: "alert-success",
        WARNING: "alert-warning",
        DANGER: "alert-danger",
    },
    AlertDialog: (props) => {
        const data = props.data;
        let content = "ErrorPage",
            alertClass = "",
            iconElement = "", ref = data.ref ? data.ref : null
        ;

        if(data){
            if(data.content){
                content = data.content;
            }
            if(data.alertClass){
                alertClass = "alert " + data.alertClass;
            }
            if(data.iconClass){
                alertClass += "  has-icon";
                iconElement = (
                    <div className="alert-icon"><span className={data.iconClass}/></div>
                );
            }
        }
        return (
            content && alertClass ?
                <div ref={ref} className={alertClass} role="alert">
                    {iconElement}
                    <p dangerouslySetInnerHTML={{
                        __html: content
                    }}>
                    </p>
                </div>
                : ""
        );
    },
};

export default Dialogs;